import React, { ReactElement, useEffect, useState } from "react";
import { Flavor } from "./Flavor";
import { Attack } from "./Attack";
import { Skill } from "./Skills";
import { MonsterEntity } from "../../../constants/Monster";
import { MultistepCreateForm } from "../MultistepCreateForm";
import { getMonsterStatMap } from "../../../constants/Monster";
import { STRING_VALIDATION, STRING_VALIDATION_NOT_REQUIRED } from "../../../constants/Forms";
import { object } from "yup";
import { useBoolean } from "@chakra-ui/react";
import { SetElement } from "../../../Types";

const validationFlavor = object().shape({
  name: STRING_VALIDATION.max(25),
  motivation: STRING_VALIDATION_NOT_REQUIRED.max(50),
  description: STRING_VALIDATION_NOT_REQUIRED,
  background: STRING_VALIDATION_NOT_REQUIRED,
});

interface Props {
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  monsterEntity: MonsterEntity;
  onSubmit: (values: MonsterEntity) => void;
}

export function MonsterForm({ setTitle, monsterEntity, onSubmit }: Props): ReactElement {
  const [monsterLevelStats, setMonsterLevelStats] = useState(getMonsterStatMap().get(monsterEntity.powerLevel));
  const [submitDisabled, setSubmitDisabled] = useBoolean();
  const [preview, setPreview] = useState("");

  const onDestroy = () => {
    if (preview !== "") {
      URL.revokeObjectURL(preview);
    }
  };

  useEffect(() => {
    return onDestroy;
  });

  return (
    <MultistepCreateForm
      initialValues={monsterEntity}
      submitDisabled={submitDisabled}
      onSubmit={onSubmit}
      color="monster.primary"
      colorHover="monster.primaryHover"
    >
      <Flavor
        validationSchema={validationFlavor}
        setTitle={setTitle}
        submitDisabled={submitDisabled}
        setSubmitDisabled={setSubmitDisabled}
        preview={preview}
        setPreview={setPreview}
      />
      <Attack monsterStats={monsterLevelStats!} setMonsterStats={setMonsterLevelStats} />
      <Skill />
    </MultistepCreateForm>
  );
}
